<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">New Report</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Building ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <select class="form-control"
                                    name="buildingId"
                                    [ngModel]="data.buildingId"
                                    required
                                    #buildingSelect>
                                <option value="" hidden></option>
                                <option *ngFor="let build of dailyReportsService.buildingsForUpdate" [value]="build.id">
                                    {{build.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ Relieved ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Relieved</label>
                        </div>
                        <div class="col-md-8">
                            <input class="form-control" name="relieved" [ngModel]="data.relieved" required>
                        </div>
                    </div>

                    <!-- ___ Relieved By ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Relieved By</label>
                        </div>
                        <div class="col-md-8">
                            <input class="form-control" name="relievedBy" [ngModel]="data.relievedBy" required>
                        </div>
                    </div>

                    <!-- ___ Date From ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Date From</label>
                        </div>
                        <div class="col-md-8 inlineDateAndTime">
                            <!--<datetime [ngModel]="dateFrom" class="inlineDate" name="dateFrom" required></datetime>-->
                            <mat-form-field>
                                <input matInput [(ngModel)]="dateFrom" (ngModelChange)="onStartDateChange()"
                                       (focus)="dateFromPicker.open()" (click)="dateFromPicker.open()"
                                       name="dateFrom" [matDatepicker]="dateFromPicker" placeholder="Choose a date" required>
                                <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                                <mat-datepicker #dateFromPicker></mat-datepicker>
                            </mat-form-field>
                            <div class="input-group bootstrap-timepicker timepicker"
                                 (click)="openTimepicker('timepickerfrom')">
                                <input id="timepickerfrom"
                                       class="form-control input-small"
                                       name="timeFrom"
                                       [ngModel]="timeFrom" required>
                                <span class="input-group-addon">
                                    <i class="glyphicon glyphicon-time"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- ___ Date To ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Date To</label>
                        </div>
                        <div class="col-md-8 inlineDateAndTime">
                            <mat-form-field>
                                <input matInput [(ngModel)]="dateTo" [min]="dateFrom" name="dateTo"
                                       (focus)="dateToPicker.open()" (click)="dateToPicker.open()"
                                       [matDatepicker]="dateToPicker" placeholder="Choose a date" required>
                                <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                                <mat-datepicker #dateToPicker></mat-datepicker>
                            </mat-form-field>
                            <div class="input-group bootstrap-timepicker timepicker"
                                 (click)="openTimepicker('timepickerto')">
                                <input id="timepickerto"
                                       class="form-control input-small"
                                       name="timeTo"
                                       [ngModel]="timeTo" required>
                                <span class="input-group-addon">
                                    <i class="glyphicon glyphicon-time"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-modal/daily-reports-modal.component.html